"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPromptOutputJsonDescription = buildPromptOutputJsonDescription;
const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
function resolvePlaceholders(value, variables) {
    return value.replace(/{{\s*([^{}]+?)\s*}}/g, (_match, rawKey) => {
        const replacement = variables[rawKey.trim()];
        if (replacement === undefined || replacement === null)
            return '';
        return typeof replacement === 'string' ? replacement : JSON.stringify(replacement);
    });
}
function buildNodeMarkdown(key, node, variables, level = 2) {
    const headingLevel = '#'.repeat(Math.min(level, 6));
    let section = `${headingLevel} "${key}"\n`;
    if (typeof node.value === 'string' && node.value.trim()) {
        section += `${resolvePlaceholders(node.value.trim(), variables)}\n\n`;
    }
    if (isRecord(node.children)) {
        for (const [childKey, childNode] of Object.entries(node.children)) {
            if (isRecord(childNode))
                section += buildNodeMarkdown(childKey, childNode, variables, level + 1);
        }
    }
    return section;
}
function buildPromptOutputJsonDescription(outputJson, keys, variables = {}) {
    if (!isRecord(outputJson))
        return '';
    const sections = keys
        .map((key) => [key, outputJson[key]])
        .filter((entry) => isRecord(entry[1]))
        .map(([key, node]) => `${buildNodeMarkdown(key, node, variables)}---\n`);
    return sections.length ? `# Description du JSON attendu en sortie :\n\n${sections.join('\n')}`.trim() : '';
}
